<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiFileEyeOutline } from "@mdi/js";
export default {
  name: "MdiFileEyeOutline",
  data() {
    return {
      svgPath: mdiFileEyeOutline,
    };
  },
};
</script>
